export type Role='florist'|'admin';
export type OrderStatus='available'|'assigned'|'completed';
export interface User{id:number;login:string;displayName:string;role:Role}
export interface Order{id:number;order_number:string;amocrm_lead_id:number;status:OrderStatus;photo_status:string;assigned_user_id:number|null;assigned_user_name:string|null;customer_name:string|null;customer_phone:string|null;delivery_at:string|null;delivery_address:string|null;comment:string|null;composition:string|null;total_amount:string|null;photo_count:string;gallery_available:boolean;printed_at:string|null;print_count:number;print_status?:'idle'|'printing'|'waiting_paper'|'waiting_connection'|'failed';printed_sheets?:string;last_print_error?:string|null}
export type PaperWidth='80mm'|'70mm'|'60mm';
export interface PrinterSettings{autoPrint:boolean;host:string;port:number;paperWidth:PaperWidth}
export interface AdminUser{id:number;login:string;display_name:string;role:Role;active:boolean;created_at?:string}
export interface AuditEvent{id:number;action:string;entity_type:string;entity_id:string;details:Record<string,unknown>;created_at:string;actor:string|null}
export interface IntegrationEvent{id:number;provider:string;operation:string;aggregate_id:string|null;success:boolean;error_message:string|null;created_at:string}
export function formatOrderNumber(orderNumber: string | null | undefined): string {
  if (!orderNumber) return '';
  const trimmed = orderNumber.trim();
  if (trimmed.includes('-')) return trimmed;
  const match = trimmed.match(/^([A-Za-zА-Яа-яЁё]{2})([0-9A-Za-zА-Яа-яЁё]+)$/);
  if (match) {
    return `${match[1]}-${match[2]}`;
  }
  return trimmed;
}
